/**
 * Default document category slugs for i18n lookup.
 * Canonical English names in the DB map to stable translation keys.
 */

export const DEFAULT_DOCUMENT_CATEGORY_SLUG_BY_NAME: Record<string, string> = {
  Report: "report",
  Certificate: "certificate",
  Diagram: "diagram",
  Analysis: "analysis",
  Policy: "policy",
  Spreadsheet: "spreadsheet",
  Contract: "contract",
  Checklist: "checklist",
  Uncategorized: "uncategorized",
} as const;

export type DocumentCategorySlug =
  (typeof DEFAULT_DOCUMENT_CATEGORY_SLUG_BY_NAME)[keyof typeof DEFAULT_DOCUMENT_CATEGORY_SLUG_BY_NAME];

export interface DocumentCategoryLabelInput {
  name: string;
  slug?: string | null;
}

export function resolveDocumentCategorySlug(
  category: DocumentCategoryLabelInput,
): string | undefined {
  if (category.slug) {
    return category.slug;
  }
  return DEFAULT_DOCUMENT_CATEGORY_SLUG_BY_NAME[category.name];
}
